export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/GM-3f4b6e8b2ea9b5beab9322317edd3e8f.png";